import React from "react";
import { Skeleton } from "boneyard-js/react";
import StatCard from "../../components/StatCard";

// Public capture-only route for the boneyard CLI.
//
// Some skeletons live behind an auth gate (the seller/buyer dashboard,
// /dashboard/profile, etc.). The CLI runs in headless Chromium without
// the persisted JWT in localStorage, so when it visits an auth-gated
// page it gets redirected to /login and never renders the wrapped
// <Skeleton>. To capture those bones anyway, this route renders the
// same wrappers on a public URL with hardcoded content that mimics
// what the real authed page would render.
//
// The CLI auto-discovers /_boneyard via filesystem route scanning.
// At runtime, no real user navigates here — it's a capture sink.
const Fixtures: React.FC = () => {
  return (
    <div style={{ padding: 24, display: "flex", flexDirection: "column", gap: 24 }}>
      <h1 style={{ fontSize: 16, color: "var(--text-muted)" }}>
        Boneyard capture page — not user-facing
      </h1>

      {/* stat-card: rendered on /dashboard (Buyer + Seller home) for
          metric tiles. Real content comes from API; this fixture stamps
          a representative tile so the CLI can measure its layout. */}
      <div style={{ maxWidth: 320 }}>
        <Skeleton name="stat-card" loading={false}>
          <StatCard
            title="Active bids"
            value="12"
            icon="bi-graph-up"
            tone="primary"
          />
        </Skeleton>
      </div>

      {/* profile-info: rendered on /dashboard/profile under the Personal
          info heading. The real component is a stack of label+value
          rows inside a card. Fixture mirrors that shape. */}
      <div style={{ maxWidth: 720 }}>
        <Skeleton name="profile-info" loading={false}>
          <div className="payMentCard p-4">
            {[
              ["Code", "#12345678"],
              ["Full name", "Jane Mitchell Hayes"],
              ["Email", "jane.hayes@example.com"],
              ["Date of birth", "12-04-1990"],
              ["Phone", "+1 (415) 555-0142"],
              ["Speciality", "Oil Painting"],
              ["Address", "742 Evergreen Terrace, Springfield, OR 97477"],
            ].map(([label, value], i, arr) => (
              <React.Fragment key={label}>
                <div className="d-sm-flex justify-content-between align-items-center p-3 gap-2">
                  <span className="previewRow__label">{label}</span>
                  <span className="previewRow__value">{value}</span>
                </div>
                {i < arr.length - 1 && <hr className="opacity-5 m-0" />}
              </React.Fragment>
            ))}
          </div>
        </Skeleton>
      </div>
    </div>
  );
};

export default Fixtures;
